const PAYMENT_MODE_DEBIT_CARD = 'DEBIT_CARD';
const PAYMENT_MODE_NET_BANKING = 'NET_BANKING';
const PAYMENT_MODE_RUPAY_CARD = 'RUPAY_CARD';
const PAYMENT_MODE_UPI_PAYMENT = 'UPI';

export const RAZORPAY_PAYMENT_OPTIONS = [
  PAYMENT_MODE_NET_BANKING,
  PAYMENT_MODE_DEBIT_CARD,
  PAYMENT_MODE_UPI_PAYMENT,
];

export const DEFAULT_PAYMENT_MODES = [
  PAYMENT_MODE_DEBIT_CARD,
  PAYMENT_MODE_RUPAY_CARD,
];

export const BANK_CODES = [
  {
    value: 'ADB',
    razorPayCode: 'ANDB',
    label: 'ANDHRA BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },

  {
    value: 'ADC',
    razorPayCode: '',
    label: 'Andhra Bank Corporate',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'ALB',
    razorPayCode: 'ALLA',
    label: 'Allahabad Bank',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'AUB',
    razorPayCode: 'AUBL',
    label: 'AU Small Finance Bank',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'UTI',
    razorPayCode: 'UTIB',
    label: 'AXIS BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.axisbank.com/',
  },
  {
    value: 'BDN',
    razorPayCode: 'BDBL',
    label: 'BANDHAN BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'BBK',
    razorPayCode: 'BBKM',
    label: 'Bank of Bahrain and Kuwait',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'BBC',
    razorPayCode: '',
    label: 'Bank of Baroda Corporate',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    allowedForSip: true,
    url: 'http://www.bankofbaroda.com/',
  },
  {
    value: 'BBR',
    razorPayCode: 'BARB',
    label: 'BANK OF BARODA',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    allowedForSip: true,
    url: 'http://www.bankofbaroda.com/',
  },
  {
    value: 'BCB',
    razorPayCode: 'BACB',
    label: 'BASSEIN CATHOLIC COOP BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'BOM',
    razorPayCode: 'MAHB',
    label: 'BANK OF MAHARASHTRA',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    allowedForSip: true,
    url: 'http://www.bankofmaharashtra.in/',
  },
  {
    value: 'BOI',
    razorPayCode: 'BKID',
    label: 'BANK OF INDIA',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'BMN',
    razorPayCode: '',
    label: 'BHARATIYA MAHILA BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'CNB',
    razorPayCode: 'CNRB',
    label: 'CANARA BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://netbanking.canarabank.in',
  },
  {
    value: 'CSB',
    razorPayCode: 'CSBK',
    label: 'CATHOLIC SYRIAN BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.csbnet.co.in/',
  },
  {
    value: 'CBI',
    razorPayCode: 'CBIN',
    label: 'CENTRAL BANK OF INDIA',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.centralbankofindia.co.in/',
  },
  {
    value: 'CITI',
    razorPayCode: 'CITI',
    label: 'CITI BANK',
    allowedForSip: false,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.citibank.co.in/',
  },
  {
    value: 'CUB',
    razorPayCode: 'CIUB',
    label: 'CITY UNION BANK LIMITED',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.cityunionbank.com/',
  },
  {
    value: 'CPN',
    razorPayCode: '',
    label: 'Corporate Punjab National Bank',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'CRP',
    razorPayCode: 'CORP',
    label: 'CORPORATION BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.corpbank.com/',
  },
  {
    value: 'COB',
    razorPayCode: 'COSB',
    label: 'THE COSMOS CO OPERATIVE BANK LIMITED',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.cosmosbank.com/',
  },
  {
    value: 'DC2',
    razorPayCode: 'DCBL',
    label: 'DCB BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'DEN',
    razorPayCode: 'BKDN',
    label: 'DENA BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.denabank.com/',
  },
  {
    value: 'DBK',
    razorPayCode: 'DEUT',
    label: 'DEUSTCHE BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'DBS',
    razorPayCode: 'DBSS',
    label: 'DBS BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'DCB',
    razorPayCode: '',
    label: 'Development Credit Bank',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'DLB',
    razorPayCode: 'DLXB',
    label: 'DHANALAKSHMI BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.dhanbank.com/',
  },
  {
    value: 'EQB',
    razorPayCode: 'ESFB',
    label: 'EQUITAS SMALL FINANCE BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'ESF',
    razorPayCode: '',
    label: 'ESAF SMALL FINANCE BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'FBK',
    razorPayCode: 'FDRL',
    label: 'FEDERAL BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'HDF',
    razorPayCode: 'HDFC',
    label: 'HDFC BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://netbanking.hdfcbank.com/netbanking/',
  },
  {
    value: 'HSB',
    razorPayCode: 'HSBC',
    label: 'HSBC BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.hsbc.co.in/1/2/ALL_SITE_PAGES/HUB_PIB/',
  },
  {
    value: 'ICI',
    razorPayCode: 'ICIC',
    label: 'ICICI BANK LIMITED',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://infinity.icicibank.com/corp/Login.jsp',
  },
  {
    value: 'IDB',
    razorPayCode: 'IBKL',
    label: 'IDBI BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.idbibank.com/',
  },
  {
    value: 'IDN',
    razorPayCode: 'IDFB',
    label: 'IDFC BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'INB',
    razorPayCode: 'IDIB',
    label: 'INDIAN BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.indian-bank.com/',
  },
  {
    value: 'IOB',
    razorPayCode: 'IOBA',
    label: 'INDIAN OVERSEAS BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'IDS',
    razorPayCode: 'INDB',
    label: 'INDUSIND BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.indusind.com/',
  },
  {
    value: 'JKB',
    razorPayCode: 'JAKA',
    label: 'JAMMU AND KASHMIR BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'JSB',
    razorPayCode: 'JSBP',
    label: 'JANATA SAHAKARI BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'KJB',
    razorPayCode: 'KJSB',
    label: 'KALYAN JANATA SAHAKARI BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'KBL',
    razorPayCode: 'KARB',
    label: 'KARNATAKA BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'KVG',
    razorPayCode: 'KVGB',
    label: 'KARNATAKA VIKAS GRAMEENA BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'KLB',
    razorPayCode: 'KCCB',
    label: 'KALUPUR COMMERCIAL COOPERATIVE BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'KVB',
    razorPayCode: 'KVBL',
    label: 'KARUR VYSYA BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.kvb.co.in/',
  },
  {
    value: '162',
    razorPayCode: 'KKBK',
    label: 'KOTAK MAHINDRA BANK LIMITED',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.kotak.com',
  },
  {
    value: 'LVC',
    razorPayCode: '',
    label: 'Lakshmi Vilas Bank Corporate',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'LVR',
    razorPayCode: 'LAVB',
    label: 'LAXMI VILAS BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'MSB',
    razorPayCode: 'MSNU',
    label: 'THE MEHSANA URBAN COOPERATIVE BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'NKB',
    razorPayCode: 'NKGS',
    label: 'NKGSB COOPERATIVE BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'OBC',
    razorPayCode: 'ORBC',
    label: 'ORIENTAL BANK OF COMMERCE',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'PMC',
    razorPayCode: 'PMCB',
    label: 'PUNJAB AND MAHARSHTRA COOPERATIVE BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.pmcbank.com',
  },
  {
    value: 'PSB',
    razorPayCode: 'PSIB',
    label: 'PUNJAB AND SIND BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'PNB',
    razorPayCode: 'PUNB',
    label: 'PUNJAB NATIONAL BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://netpnb.com/',
  },
  {
    value: 'RBL',
    razorPayCode: 'RATN',
    label: 'RBL BANK LIMITED',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.theratnakarbank.com/',
  },

  {
    value: 'SWB',
    razorPayCode: 'SRCB',
    label: 'SARASWAT COOPERATIVE BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },

  {
    value: 'SCB',
    razorPayCode: 'SCBL',
    label: 'STANDARD CHARTERED BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'SVC',
    razorPayCode: 'SVCB',
    label: 'THE SHAMRAO VITHAL COOPERATIVE BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.svcbank.com/',
  },
  {
    value: 'SIB',
    razorPayCode: 'SIBL',
    label: 'SOUTH INDIAN BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'SBH',
    razorPayCode: 'SBHY',
    label: 'STATE BANK OF HYDERABAD',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.onlinesbi.com/',
  },
  {
    value: 'SBI',
    razorPayCode: 'SBIN',
    label: 'STATE BANK OF INDIA',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'https://www.onlinesbi.com/',
  },
  {
    value: 'SBP',
    razorPayCode: 'STBP',
    label: 'STATE BANK OF PATIALA',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.sbp.co.in/',
  },
  {
    value: 'SRB',
    razorPayCode: '',
    label: 'SURYODAY SMALL FINANCE BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'SYD',
    razorPayCode: 'SYNB',
    label: 'SYNDICATE BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'TMB',
    razorPayCode: 'TMBL',
    label: 'TAMILNAD MERCANTILE BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'RBS',
    razorPayCode: '',
    label: 'THE ROYAL BANK OF SCOTLAND N V',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'TBB',
    razorPayCode: 'TBSB',
    label: 'THE THANE BHARAT SAHAKARI BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'TJB',
    razorPayCode: 'TJSB',
    label: 'TJSB SAHAKARI BANK LIMITED',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'TNC',
    razorPayCode: 'TNSC',
    label: 'THE TAMIL NADU STATE APEX COOPERATIVE BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'UCO',
    razorPayCode: 'UCBA',
    label: 'UCO BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.ucobank.com/',
  },
  {
    value: 'UBI',
    razorPayCode: 'UBIN',
    label: 'UNION BANK OF INDIA',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url: 'http://www.unionbankofindia.co.in/',
  },
  {
    value: 'UNI',
    razorPayCode: 'UTBI',
    label: 'UNITED BANK OF INDIA',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'VJB',
    razorPayCode: 'VIJB',
    label: 'VIJAYA BANK',
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
  },
  {
    value: 'YBK',
    razorPayCode: 'YESB',
    label: 'YES BANK',
    allowedForSip: true,
    paymentModes: [
      PAYMENT_MODE_DEBIT_CARD,
      PAYMENT_MODE_NET_BANKING,
      PAYMENT_MODE_RUPAY_CARD,
      // PAYMENT_MODE_UPI_PAYMENT,
    ],
    url:
      'https://www.yesbank.in/digital-banking/online-banking/netbanking-services',
  },
];



// WEBPACK FOOTER //
// ./constants/bankCodes.ts